import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";
import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";



export default function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

 

  
    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");

        try {
            const { error } = await supabase.auth.signInWithPassword({
                email: email.trim(),
                password,
            });

            if (error) throw error;

            toast.success("Welcome back, Devang.");
            navigate("/admin");
        } catch (err) {
            setError(err.message || "Login failed. Please try again.");
        } finally {
            setBusy(false);
        }
    };


    return (
        <div
            className="min-h-screen bg-ink text-paper flex flex-col lg:flex-row"
            data-testid="login-page"
        >
            <div className="lg:w-1/2 flex flex-col justify-between p-8 lg:p-14 min-h-[180px]">
                <Link
                    to="/"
                    data-testid="login-back-home"
                    className="group mono text-[11px] tracking-[0.25em] text-paper2/60 inline-flex items-center gap-2 hover:text-paper transition-colors"
                >
                    <ArrowLeft className="h-3.5 w-3.5 transition-transform group-hover:-translate-x-1" />
                    BACK TO SITE
                </Link>
                <div className="hidden lg:block">
                    <p className="mono text-xs tracking-[0.3em] text-sage">
                        _beingdevang / ADMIN
                    </p>
                    <p className="serif-it text-3xl xl:text-4xl mt-6 max-w-sm leading-snug text-paper2">
                        Editing corner — every word, link and pixel, yours to
                        steer.
                    </p>
                </div>
            </div>

            <div className="lg:w-1/2 flex items-center justify-center p-8 lg:p-14">
                <form
                    onSubmit={submit}
                    className="w-full max-w-md border border-linedark bg-ink2 p-8 lg:p-12"
                    data-testid="login-form"
                >
                    <p className="mono text-[10px] tracking-[0.3em] text-muted2">
                        01 — WHO'S THERE?
                    </p>
                    <h1 className="font-display text-3xl md:text-4xl tracking-tight mt-3">
                        LOG IN
                    </h1>

                    <label className="block mt-10">
                        <span className="mono text-[10px] tracking-[0.25em] text-muted2">
                            EMAIL
                        </span>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="login-email-input"
                            className="mt-2 w-full bg-transparent border-b border-linedark focus:border-sage outline-none py-3 text-base transition-colors"
                        />
                    </label>

                    <label className="block mt-8">
                        <span className="mono text-[10px] tracking-[0.25em] text-muted2">
                            PASSWORD
                        </span>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="login-password-input"
                            className="mt-2 w-full bg-transparent border-b border-linedark focus:border-sage outline-none py-3 text-base transition-colors"
                        />
                    </label>

                    {error && (
                        <p
                            className="mt-6 text-sm text-red-300 border border-red-400/30 bg-red-400/10 px-4 py-3"
                            data-testid="login-error"
                        >
                            {error}
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={busy}
                        data-testid="login-submit-button"
                        className="group mt-10 w-full inline-flex items-center justify-center gap-3 bg-sage text-ink px-8 py-4 mono text-[11px] tracking-[0.25em] uppercase transition-colors hover:bg-paper disabled:opacity-60"
                    >
                        {busy ? (
                            <Loader2 className="h-4 w-4 animate-spin" />
                        ) : (
                            <>
                                ENTER THE STUDIO
                                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1.5" />
                            </>
                        )}
                    </button>


                </form>
            </div>
        </div>
    );
}
